import { render, staticRenderFns } from "./EditOutsourcing.vue?vue&type=template&id=1168bcfe&"
import script from "./EditOutsourcing.vue?vue&type=script&lang=js&"
export * from "./EditOutsourcing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports